import React from "react";
import { NO_RECORD_FOUND_TEXT_WITH_TITLE_AND_DESCRIPTION } from "@/utils/constants/appConstants/commonConstants";
interface NoDataAvailableProps {
  children: React.ReactNode;
}

const NoDataAvailable: React.FC<NoDataAvailableProps> = ({ children }) => {
  return (
    <div className="gs-no-data flex justify-center text-center">
      <span>{children}</span>
    </div>
  );
};

export default NoDataAvailable;

export const NoDataAvailableWithText: React.FC<{ type: string }> = ({ type }) => {
  const { TITLE, DESCRIPTION } = NO_RECORD_FOUND_TEXT_WITH_TITLE_AND_DESCRIPTION[type.toUpperCase()] || { TITLE: "", DESCRIPTION: "" };
  return (
      <div className='container-fluid'>
          <div className="d-flex justify-content-center text-center center m-5">
              <span className='color-Black'>
                  <h4 className="center font-weight-normal">{TITLE}</h4>
                  <br />
                  <p className="center">{DESCRIPTION}</p>
              </span>
          </div>
      </div>
  );
}

